import Vue from 'vue'
import Router from 'vue-router'
import Home from '../components/Home.vue'
import Thanks from '../components/Thanks.vue'

Vue.use(Router)

const scrollBehavior = function (to, from, savedPosition) {
  if (savedPosition) {
    savedPosition.x = 0
    savedPosition.y = 0
    return savedPosition
  } else {
    const position = {}

    if (to.hash) {
      position.selector = to.hash
      if (document.querySelector(to.hash)) {
        return position
      }
      return false
    }
    return { x: 0, y: 0 }
  }
}

const router = new Router({
  mode: 'history',
  scrollBehavior,
  routes: [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/gracias',
        name: 'Thanks',
        component: Thanks
    }
  ]
})


router.beforeEach((to, from, next) => {
  next()
})

export default router